import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyhole2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyhole-2, lock, unlock"><path d="M12 2C15.866 2 19 5.13401 19 9C19 11.5125 17.675 13.7129 15.6895 14.9473L17.2725 19.6963C17.6502 20.8295 16.8068 22 15.6123 22H8.3877C7.19322 22 6.34981 20.8295 6.72754 19.6963L8.30957 14.9473C6.32437 13.7129 5 11.5122 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconKeyhole2;
